<template>
  <div>
    <v-alert v-if="$route.query.status == 200" outlined type="success" text
      >Success! <br />
      Your vote has been successfully submitted.
    </v-alert>

    <v-alert v-else outlined type="error" text>
      Error! <br />
      Sorry, an error occured while trying to submit your vote. Please try again
      later.
    </v-alert>

    <div class="text-center">
      <v-btn depressed class="mt-5 primary" @click="goToAnalytics"
        >go to analytics</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToAnalytics() {
      window.location.href = `/voter/vote/${this.$route.params.id}`;
    },
  },
};
</script>
